/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

// Move Language-Selector into Sidebar-Footer on small screens
// FIX: 2026-05-13 (rpeter) try catch, check if set
try {
  var dom = document.querySelector('.ly-custom-0');
  var target = document.querySelector('#sidebar-menu .Drawer__Footer .SidebarMenu__CurrencySelector');
  if (dom && target && document.body.clientWidth < 1240) {
    target.parentNode.appendChild(dom);
  }
} catch (e) {
  console.warn('Language-Selector move failed:', e);
}


/* ============================================================
   Accessibility Fix: aria-hidden + focusable content
   ------------------------------------------------------------
   Synchronizes the `inert` attribute with `aria-hidden` so that
   hidden containers (drawers, mega menus, carousel cells)
   are also inaccessible via the keyboard.

   FIX:    Eye-Able Punkt "Aria-Hidden Element hat fokussierbaren Inhalt"
   WCAG:   4.1.2 Name, Role, Value (Level A)
   ADD:    2026-05-13 (rpeter)
   ============================================================ */
(function() {
  'use strict';

  function syncInert(element) {
    if (!element || !element.setAttribute) return;
    var isHidden = element.getAttribute('aria-hidden') === 'true';

    if (isHidden && !element.hasAttribute('inert')) {
      element.setAttribute('inert', '');
    } else if (!isHidden && element.hasAttribute('inert')) {
      element.removeAttribute('inert');
    }
  }

  function initializeInert() {
    document.querySelectorAll('[aria-hidden="true"]').forEach(syncInert);
  }

  function watchAriaHiddenChanges() {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
          syncInert(mutation.target);
        }
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType !== 1) return;
            if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
              syncInert(node);
            }
            if (node.querySelectorAll) {
              node.querySelectorAll('[aria-hidden="true"]').forEach(syncInert);
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['aria-hidden'],
      subtree: true,
      childList: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initializeInert();
      watchAriaHiddenChanges();
    });
  } else {
    initializeInert();
    watchAriaHiddenChanges();
  }
})();

/* ============================================================
   Accessibility Fix #2: Boost-Filter Heading-Button-Konflikt
   ------------------------------------------------------------
   Boost Commerce (bc-sf-filter) renders filter categories as
   <h3 role="button" aria-expanded=“true” aria-controls=“...”>.
   This combination (heading + button role + aria-expanded)
   is considered a WCAG violation because heading and button
   semantics conflict.

   Solution: <h3> remains as the heading, while the interactive
   part is moved to a nested <button>. ARIA attributes are moved to the button.

   FIX:    Eye-Able Punkt "ARIA-Wert oder -Attribut nicht unterstuetzt"
           Plus teilweise "Sprung in der Ueberschriften-Reihenfolge"
           h3 ohne strukturellen Kontext werden faktisch zu Buttons).

   WCAG:   4.1.2 Name, Role, Value (Level A)
   ADD:    2026-05-13 (rpeter)
   ============================================================ */
(function() {
  'use strict';

  var SELECTOR_FILTER_WRAPPER = '#bc-sf-filter-options-wrapper';
  var SELECTOR_PROBLEMATIC_H3 = 'h3[role="button"][aria-controls^="bc-sf-filter"]';
  var FIXED_MARKER = 'a11yFixed';

  /**
   * Converts a single `h3` tag to `<h3><button>...</button></h3>`
   * - Moves ARIA attributes to the button
   * - Keeps the `h3` tag as a plain heading (for screen reader navigation)
   * - Handles both click handler scenarios (directly on the `h3` OR bubbling)
   */
  function transformBoostFilterHeading(h3) {
    // Already transformed? Skip.
    if (h3.dataset[FIXED_MARKER] === 'true') return;
    if (h3.querySelector(':scope > button')) return;

    var ariaControls = h3.getAttribute('aria-controls') || '';
    var ariaExpanded = h3.getAttribute('aria-expanded') || 'true';
    var originalContent = h3.innerHTML;

    // Create a button with migrated attributes
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'bc-sf-filter-block-title-button';
    button.setAttribute('aria-controls', ariaControls);
    button.setAttribute('aria-expanded', ariaExpanded);
    button.innerHTML = originalContent;

    // Remove button semantics from h3 (leaves it as a plain heading)
    h3.removeAttribute('role');
    h3.removeAttribute('tabindex');
    h3.removeAttribute('aria-controls');
    h3.removeAttribute('aria-expanded');

    // Clicking the button automatically updates the `aria-expanded` attribute
    // (Boost's internal status toggle receives the actual click event
    //  via event bubbling or through the container's click handler.)
    button.addEventListener('click', function() {
      var oldExpanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!oldExpanded));
    });

    // Replace content
    h3.innerHTML = '';
    h3.appendChild(button);

    // Mark as completed
    h3.dataset[FIXED_MARKER] = 'true';
  }

  /**
   * Find all problematic h3 tags in the filter wrapper and transform them.
   */
  function transformAllBoostFilterHeadings() {
    var wrappers = document.querySelectorAll(SELECTOR_FILTER_WRAPPER);
    if (wrappers.length === 0) return; // Nicht auf Collection-Seite, nichts zu tun

    wrappers.forEach(function(wrapper) {
      wrapper.querySelectorAll(SELECTOR_PROBLEMATIC_H3).forEach(transformBoostFilterHeading);
    });
  }

  /**
   * Keep an eye on the filter wrapper: When Boost AJAX-mode re-renders,
   * the transformations run automatically again.
   */
  function watchBoostFilterRerenders() {
    var wrappers = document.querySelectorAll(SELECTOR_FILTER_WRAPPER);
    if (wrappers.length === 0) return;

    wrappers.forEach(function(wrapper) {
      var observer = new MutationObserver(function(mutations) {
        var needsRetransform = false;
        mutations.forEach(function(m) {
          if (m.type === 'childList' && m.addedNodes.length > 0) {
            needsRetransform = true;
          }
        });
        if (needsRetransform) {
          transformAllBoostFilterHeadings();
        }
      });

      observer.observe(wrapper, {
        childList: true,
        subtree: true
      });
    });
  }

  /**
   * Initialization with a delay, because Boost renders asynchronously.
   * We try multiple times in case Boost is still loading.
   */
  function initBoostFilterFix() {
    var attempts = 0;
    var maxAttempts = 20; // 20 x 250ms = 5 Sekunden Wartezeit

    var interval = setInterval(function() {
      attempts++;
      var wrapper = document.querySelector(SELECTOR_FILTER_WRAPPER);
      var hasH3 = wrapper && wrapper.querySelector(SELECTOR_PROBLEMATIC_H3);

      if (hasH3) {
        transformAllBoostFilterHeadings();
        watchBoostFilterRerenders();
        clearInterval(interval);
      } else if (attempts >= maxAttempts) {
        clearInterval(interval);
        // Filter nicht gefunden - vermutlich nicht auf Collection-Seite, das ist OK
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBoostFilterFix);
  } else {
    initBoostFilterFix();
  }
})();